module.exports = __webpack_public_path__ + "static/media/noor-photo-11.9ce1a44c.jpg";